export const ORDER_ASCENDING = 'ascending';
export const ORDER_DESCENDING = 'descending';
export const ORDER_NONE = 'none';
export const OFFSET_DIVERGING = 'diverging';
export const OFFSET_NONE = 'none';
export const OFFSET_EXPAND = 'expand';
export const OFFSET_WIGGLE = 'wiggle';
